import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import MaterialTable, { MTableAction } from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { Input } from '../../../assets/styled/Element';
import { useSnackbar } from 'notistack';
import SrearchPointReasonRule from '../../../components/Search/SrearchPointReasonRule';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { faFileEdit, faTrashAlt } from '@fortawesome/pro-duotone-svg-icons';
import { useHistory } from 'react-router-dom';
import { faPlus } from '@fortawesome/pro-light-svg-icons';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));

function PointReason(props) {
   const history = useHistory();
   const addActionRef = useRef();
   const classes = useStyles();
   const [resp, setResp] = useState([]);
   const [data, setData] = useState([]);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

   useEffect(() => {
      getData();
   }, []);

   const getData = () => {
      Axios.get('/GSB/dashboard/pointreason/GetPointReasonList')
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         });
   };

   useEffect(() => {
      setTableData();
   }, [resp]);

   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
               },
            );
         });
         setData(formatted);
      }
   };

   const refreshData = () => {
      getData();
   };

   return (
      <Paper style={myContainerStyle.root}>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>จัดการเหตุผลการให้คะแนน</Typography>
            </Box>
            <Box mx={1}>
               <Button
                  variant='contained'
                  color='primary'
                  size='small'
                  startIcon={<FontAwesomeIcon icon={faPlus} />}
                  onClick={() => addActionRef.current.click()}
               >
                  เพิ่มเหตุผลการให้คะแนน
               </Button>
            </Box>
         </Box>
         <MaterialTable
            columns={[
               {
                  field: 'reasonTh',
                  title: 'เหตุผลภาษาไทย',
                  editComponent: (props) => (
                     <Input
                        type='text'
                        value={props.value}
                        onChange={(e) => props.onChange(e.target.value)}
                        placeholder={'เหตุผลภาษาไทย'}
                     />
                  ),
               },
               {
                  field: 'reasonEn',
                  title: 'เหตุผลภาษาอังกฤษ',
                  editComponent: (props) => (
                     <Input
                        type='text'
                        value={props.value}
                        onChange={(e) => props.onChange(e.target.value)}
                        placeholder={'เหตุผลภาษาอังกฤษ'}
                     />
                  ),
               },
               {
                  field: 'ruleName',
                  title: 'หลักเกณฑ์',
                  editComponent: (props) => (
                     <SrearchPointReasonRule
                        onChange={(e) => props.onChange(e)}
                        defaultOptions
                        placeholder={props.value && props.value}
                        level={1}
                     />
                  ),
                  sorting: false,
                  export: false,
                  headerStyle: {
                     textAlign: 'center',
                  },
                  render: (rowData) =>
                     `${rowData.ruleCode && rowData.ruleCode} : ${
                        rowData.ruleNameTh && rowData.ruleNameTh
                     }`,
               },
            ]}
            data={data}
            options={{
               // selection: true,
               showTitle: false,
               headerStyle: headerStyle,
               actionsColumnIndex: -1,
               actionsCellStyle: {
                  color: '#ccc',
               },
               addRowPosition: 'first',
               padding: 'dense',
               pageSize: 5,
               pageSizeOptions: [5, 10, 25, 50, 100],
            }}
            localization={{
               body: {
                  deleteTooltip: 'ลบ',
                  editTooltip: 'แก้ไข',
                  editRow: { deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?' },
               },
               header: { actions: 'ตัวจัดการ' },
            }}
            style={tableStyle}
            components={{
               Action: (props) => {
                  //If isn't the add action
                  if (
                     typeof props.action === typeof Function ||
                     props.action.tooltip !== 'Add'
                  ) {
                     return <MTableAction {...props} />;
                  } else {
                     return (
                        <div
                           ref={addActionRef}
                           onClick={props.action.onClick}
                        />
                     );
                  }
               },
            }}
            actions={[
               {
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        icon={faRedoAlt}
                        size={'xs'}
                     />
                  )),
                  tooltip: 'Refresh Data',
                  isFreeAction: true,
                  onClick: () => refreshData(),
               },
            ]}
            icons={{
               ...tableIcons,
               Delete: React.forwardRef((props, ref) => (
                  <FontAwesomeIcon
                     ref={ref}
                     {...props}
                     color='#ed1c24'
                     icon={faTrashAlt}
                  />
               )),
               Edit: React.forwardRef((props, ref) => (
                  <FontAwesomeIcon
                     ref={ref}
                     {...props}
                     color='#00a2e8'
                     icon={faFileEdit}
                  />
               )),
               Check: React.forwardRef((props, ref) => (
                  <Button
                     style={{ padding: 2, minWidth: 50 }}
                     variant='contained'
                     color='primary'
                     size={'small'}
                     ref={ref}
                     {...props}
                  >
                     ยืนยัน
                  </Button>
               )),
               Clear: React.forwardRef((props, ref) => (
                  <Button
                     style={{ padding: 2, minWidth: 50 }}
                     variant='contained'
                     size={'small'}
                     ref={ref}
                     {...props}
                  >
                     ยกเลิก
                  </Button>
               )),
            }}
            editable={{
               onRowAdd: (newData) => {
                  return new Promise((resolve, reject) => {
                     Axios.post(
                        '/GSB/dashboard/pointreason/CreatePointReason',
                        {
                           nameTh: newData.reasonTh ? newData.reasonTh : '',
                           nameEn: newData.reasonEn ? newData.reasonEn : '',
                           ruleId: newData.ruleName.value,
                        },
                     )
                        .then((resp) => {
                           enqueueSnackbar('สร้างรายการสำเร็จ!!', {
                              variant: 'success',
                           });
                           resolve(refreshData());
                        })
                        .catch((e) => {
                           LogToBackend(e);
                           reject(e);
                           if (e.response) {
                              const response = e.response.data;
                              enqueueSnackbar(response.errorAppMessageTh, {
                                 variant: 'error',
                              });
                           } else console.error('site error');
                        });
                  });
               },
               onRowUpdate: (newData, oldData) => {
                  return new Promise((resolve, reject) => {
                     Axios.post('/GSB/dashboard/pointreason/EditPointReason', {
                        nameTh: newData.reasonTh ? newData.reasonTh : null,
                        nameEn: newData.reasonEn ? newData.reasonEn : null,
                        reasonId: oldData.reasonId,
                        ruleId: newData.ruleName.value,
                     })
                        .then((resp) => {
                           enqueueSnackbar('แก้ไขรายการสำเร็จ!!', {
                              variant: 'success',
                           });
                           resolve(refreshData());
                        })
                        .catch((e) => {
                           LogToBackend(e);
                           reject(e);
                           if (e.response) {
                              const response = e.response.data;
                              enqueueSnackbar(response.errorAppMessageTh, {
                                 variant: 'error',
                              });
                           } else console.error('site error');
                        });
                  });
               },
               onRowDelete: (oldData) => {
                  return new Promise((resolve, reject) => {
                     Axios.post(
                        '/GSB/dashboard/pointreason/DeletePointReason',
                        {
                           reasonId: oldData.reasonId,
                        },
                     )
                        .then((resp) => {
                           enqueueSnackbar('ลบรายการสำเร็จ!!', {
                              variant: 'success',
                           });
                           resolve(refreshData());
                        })
                        .catch((e) => {
                           LogToBackend(e);
                           reject(e);
                           if (e.response) {
                              const response = e.response.data;
                              enqueueSnackbar(response.errorAppMessageTh, {
                                 variant: 'error',
                              });
                           } else console.error('site error');
                        });
                  });
               },
            }}
         />
      </Paper>
   );
}

export default PointReason;
